var _path, _path2, _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSikanaMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 6.89655C23.5 7.29943 23.384 7.92275 23.1476 8.7416C22.9142 9.54971 22.5746 10.512 22.1523 11.5776C21.3081 13.7082 20.1435 16.2276 18.8678 18.7106C17.592 21.1936 16.2097 23.631 14.9322 25.5988C14.2933 26.5829 13.6842 27.444 13.1308 28.1325C12.7057 28.6614 12.3254 29.0733 12 29.3599C11.6746 29.0733 11.2943 28.6614 10.8692 28.1325C10.3158 27.444 9.70671 26.5829 9.06781 25.5988C7.79029 23.631 6.40804 21.1936 5.13223 18.7106C3.85647 16.2276 2.69186 13.7082 1.84765 11.5776C1.42542 10.512 1.08578 9.54971 0.852447 8.7416C0.616013 7.92275 0.5 7.29943 0.5 6.89655C0.5 5.24754 1.66729 3.65838 3.76386 2.45346C5.84682 1.25636 8.75766 0.5 12 0.5C15.2423 0.5 18.1532 1.25636 20.2361 2.45346C22.3327 3.65838 23.5 5.24754 23.5 6.89655Z",
    fill: "#C4C4C4",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11C20 15.4183 16.4183 19 12 19C7.58172 19 4 15.4183 4 11C4 6.58172 7.58172 3 12 3C16.4183 3 20 6.58172 20 11Z",
    fill: "#F8F4F4",
    stroke: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9_226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 14.1691C7.5 12.38 9.26581 10.7857 11.638 10.7857C14.0102 10.7857 15.776 12.38 15.776 14.1691C15.776 14.6247 15.667 14.876 15.5339 15.0294C15.3961 15.1881 15.1726 15.3113 14.81 15.3912C14.4449 15.4717 13.9896 15.4975 13.4412 15.4998C13.1697 15.501 12.8836 15.4965 12.5808 15.4915L12.5595 15.4912C12.2648 15.4864 11.9553 15.4814 11.638 15.4814C11.3207 15.4814 11.0112 15.4864 10.7165 15.4912L10.6952 15.4915C10.3924 15.4965 10.1063 15.501 9.83479 15.4998C9.28641 15.4975 8.83109 15.4717 8.46605 15.3912C8.10339 15.3113 7.87987 15.1881 7.7421 15.0294C7.60899 14.876 7.5 14.6247 7.5 14.1691Z",
    fill: "#C4C4C4",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1503 8.14286C10.1503 7.19948 10.8511 6.5 11.638 6.5C12.4249 6.5 13.1257 7.19948 13.1257 8.14286C13.1257 9.08623 12.4249 9.78571 11.638 9.78571C10.8511 9.78571 10.1503 9.08623 10.1503 8.14286Z",
    fill: "#C4C4C4",
    stroke: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_9_226)"
  }, /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 3.60137,
    y2: -0.5,
    transform: "matrix(0.61902 0.785375 -0.61902 0.785375 14 7)",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 3.61887,
    y2: -0.5,
    transform: "matrix(0.603047 -0.797706 0.634894 0.772599 14.3941 9.8868)",
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9_226",
    x: 3,
    y: 6,
    width: 17.276,
    height: 18,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9_226"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9_226",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_9_226",
    x: 9.75922,
    y: 6.21463,
    width: 11.0891,
    height: 11.6722,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9_226"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9_226",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSikanaMarker);
export default __webpack_public_path__ + "static/media/Sikana-marker.2d03f432e4d70f573d7f60572c1739e7.svg";
export { ForwardRef as ReactComponent };